<h2 mat-dialog-title> Modificar pesaje</h2>
<mat-dialog-content>

  @if (showProgressBar) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <form [formGroup]="form">
    <mat-form-field appearance="outline" floatLabel="always" class='formField'>
      <mat-label>Chófer</mat-label>
      <mat-select formControlName="usuario" required>
        @for (usuario of usuarios; track usuario) {
          <mat-option [value]="usuario.id">{{usuario.name}} {{usuario.surname}} </mat-option>
        }
      </mat-select>
      <mat-error>Debes seleccionar un usuario.</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always" class='formField'>
      <mat-label>Camión</mat-label>
      <mat-select formControlName="matricula" required>
        @for (camion of camiones; track camion) {
          <mat-option [value]="camion.id">{{camion.matricula}}</mat-option>
        }
      </mat-select>
      <mat-error>Debes seleccionar un camión.</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always"  class='formField'>
      <mat-label>Nº Albarán</mat-label>
      <input matInput type="number" placeholder="Nº Albarán" formControlName="nAlbaran" required>
      <mat-error>Debes poner un Nº de Albarán.</mat-error>
      <mat-error>Debe ser un número.</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always" class='formField'>
      <mat-label>Residuo</mat-label>
      <mat-select formControlName="material" required>
        @for (material of materiales; track material) {
          <mat-option [value]="material.id">{{material.nombre}}</mat-option>
        }
      </mat-select>
      <mat-error>Debes seleccionar un material.</mat-error>
    </mat-form-field>
    @if (!readonlyPeso) {
      <mat-form-field appearance="outline" floatLabel="always" class='formField'>
        <mat-label>Peso</mat-label>
        <input matInput type="number" placeholder="Peso" formControlName="peso" [readonly]="readonlyPeso" required>
        <mat-error>Debes poner un peso.</mat-error>
        <mat-error>Debe ser un número.</mat-error>
      </mat-form-field>
    }
    <mat-form-field appearance="outline" floatLabel="always" class='formField'>
      <mat-label>Fecha</mat-label>
      <div (click)="fechaPicker.open()">
        <input matInput [matDatepicker]="fechaPicker" (dateChange)="dateChange($event)" formControlName="fecha" disabled placeholder="Fecha" required>
      </div>
      <mat-datepicker-toggle matSuffix [for]="fechaPicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #fechaPicker disabled="false"></mat-datepicker>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always" class='formField'>
      <mat-label>Hora</mat-label>
      <input matInput [ngxTimepicker]="timePicker" [format]="24" formControlName="hora" required>
      <ngx-material-timepicker #timePicker></ngx-material-timepicker>
      <mat-error>Debes indicar la hora.</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" floatLabel="always" class='formField'>
      <mat-label>Observaciones</mat-label>
      <input matInput placeholder="Observaciones" formControlName="descripcion">
    </mat-form-field>
  </form>


</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancelar</button>
  <button mat-button (click)="save()" [disabled]='saveDisabled'>Guardar</button>
</mat-dialog-actions>
